__turbopack_context__.v({
  "chip": "KeywordChip-module__ogNu2W__chip",
  "icon": "KeywordChip-module__ogNu2W__icon",
  "ink": "KeywordChip-module__ogNu2W__ink",
  "light": "KeywordChip-module__ogNu2W__light",
  "mid": "KeywordChip-module__ogNu2W__mid",
});
